<template>
    <confirm-dialog
        v-if="isUserHost"
        v-model="shows"
        v-bind="{
            title: '참여승인',
            text_exit: '거부',
            text_next: '승인',
            exit,
            next,
            loading,
        }"
    >
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-sheet class="page-text--lg font-weight-bold text-center"> 참여를 승인하시겠습니까? </v-sheet>
    </confirm-dialog>
    <div v-else>
        <slot name="activator" v-bind="{ on: { click } }" />
    </div>
</template>

<script>
import api from "@/api";
import { initExpoEmployee, initExpoProgram } from "@/assets/variables/inits";
import ConfirmDialog from "@/components/dumb/confirm-dialog.vue";

export default {
    components: {
        ConfirmDialog,
    },
    props: {
        value: { type: Object, default: initExpoEmployee },
        program: { type: Object, default: initExpoProgram },
        isUserHost: { type: Boolean, default: false },
    },
    data: () => ({
        shows: false,
        loading: false,
    }),
    methods: {
        async exit() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { employee } = await api.v1.expo.programs.employees.put({
                    _id: this.value._id,
                    _program: this.value._program,
                    isGranted: false,
                });
                this.$emit("input", employee);
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        async next() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { employee } = await api.v1.expo.programs.employees.put({
                    _id: this.value._id,
                    _program: this.value._program,
                    isGranted: true,
                });
                this.$emit("input", employee);
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        async click() {
            alert("권한이 없습니다");
        },
    },
};
</script>

<style>
</style>